
export function getKeywordSearchElement()
{
    return document.getElementById('keywordSearch') as HTMLInputElement | null;
}
